import { PageContainer, ProTable } from '@ant-design/pro-components';
import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import { useRef } from 'react';
import { fetchTraceAccount, queryTraceAccounts } from '../services/trace';

const ACCOUNT_TYPE = {
  own: {
    text: '自有账号',
    status: 'Success',
  },
  rival: {
    text: '竞品账号',
    status: 'Processing',
  },
};

const PLATFORM = {
  douyin: {
    text: '抖音',
    status: 'Processing',
  },
  weibo: {
    text: '微博',
    status: 'Default',
  },
  xhs: {
    text: '小红书',
    status: 'Success',
  },
};

const Accounts = () => {
  const actionRef = useRef(null);
  const { message } = App.useApp();
  const { mutateAsync: fetchAccount, isPending } = useMutation({
    mutationFn: fetchTraceAccount,
    onSuccess: () => {
      message.success('数据抓取已完成');
    },
    onError: () => {
      message.error('数据抓取失败，请稍后重试');
    },
  });

  const columns = [
    {
      title: '组织名称',
      dataIndex: 'organizationName',
    },
    {
      title: '账号类型',
      dataIndex: 'accountType',
      valueEnum: ACCOUNT_TYPE,
    },
    {
      title: '平台',
      dataIndex: 'platform',
      valueEnum: PLATFORM,
    },
    {
      title: '账号ID',
      dataIndex: 'accountId',
      copyable: true,
    },
    {
      title: '账号名称',
      dataIndex: 'name',
    },
    {
      title: '操作',
      valueType: 'option',
      render: (_, record) => [
        <Button
          key="fetch"
          type="link"
          loading={isPending}
          onClick={() => fetchAccount({ data: record })}
        >
          抓取数据
        </Button>,
      ],
    },
  ];

  return (
    <PageContainer content="厂商管理员在这里查看所有组织的监测账号，并手动触发数据抓取。">
      <ProTable
        actionRef={actionRef}
        rowKey="id"
        headerTitle="监测账号"
        request={queryTraceAccounts}
        columns={columns}
        search={{
          labelWidth: 96,
        }}
        scroll={{
          x: 'max-content',
        }}
      />
    </PageContainer>
  );
};

export default Accounts;
